import React from "react";
import { Table as AntdTable } from "antd";
import PropTypes from "prop-types";

// Lodash
import _noop from "lodash/noop";

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from "../../../constants/base.constants";
import { DEFAULT_PAGINATION_PROPS } from "./constants/tableProps";

// Components
import TableHeader from "./components/tableHeader";

// Styles
import styles from "./table.module.scss";

function Table({
  columns,
  data,
  onSearch,
  onPaginationChange,
  paginationOptions,
  searchProps,
  onRowClick,
  loading,
  showSearch,
  showPagination,
  showReload,
  onReload,
  onChange,
  filters,
  rowSelectionProps,
}) {
  const updatedPaginationOptions = showPagination
    ? {
        ...DEFAULT_PAGINATION_PROPS,
        ...paginationOptions,
        onChange: onPaginationChange,
      }
    : false;


    const styleComponent = columns.map((column) => ({
    ...column,
    title: <span style={{ color: "#cf9c46" }}>{column.title}</span>,
    }))
  return (
    <div className={styles.container}>
      <TableHeader
        onSearch={onSearch}
        searchProps={searchProps}
        showSearch={showSearch}
        onReload={onReload}
        showReload={showReload}
        filters={filters}
      />
      <AntdTable
        columns={styleComponent}
        dataSource={data}
        pagination={updatedPaginationOptions}
        onRow={(record) => ({
          onClick: () => {
            onRowClick(record);
          },
        })}
        loading={loading}
        onChange={onChange}
        rowSelection={rowSelectionProps}
      />
    </div>
  );
}

Table.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  onSearch: PropTypes.func,
  paginationOptions: PropTypes.object,
  searchProps: PropTypes.object,
  onPaginationChange: PropTypes.func,
  onRowClick: PropTypes.func,
  loading: PropTypes.bool,
  showSearch: PropTypes.bool,
  showPagination: PropTypes.bool,
  onReload: PropTypes.func,
  showReload: PropTypes.bool,
  rowSelectionProps: PropTypes.object,
};

Table.defaultProps = {
  columns: EMPTY_ARRAY,
  data: EMPTY_ARRAY,
  onSearch: _noop,
  paginationOptions: DEFAULT_PAGINATION_PROPS,
  searchProps: EMPTY_OBJECT,
  onPaginationChange: _noop,
  onRowClick: _noop,
  loading: false,
  showSearch: true,
  showPagination: true,
  onReload: _noop,
  showReload: true,
  rowSelectionProps: null,
};

export default Table;
